import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { PermissionRequestService } from '../services/permission-request.service';

@Component({
    selector: 'app-permission-request-dialog',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, DialogModule, ButtonModule],
    template: `
        <p-dialog
            header="Permission required"
            [visible]="service.visible()"
            (visibleChange)="service.visible.set($event)"
            [modal]="true"
            [style]="{ width: '440px' }"
        >
            <div class="permission-body">
                <i class="pi pi-lock permission-icon"></i>
                <p>
                    @if (service.actionLabel()) {
                        <strong>{{ service.actionLabel() }}</strong> requires elevated access.
                    } @else {
                        This action requires elevated access.
                    }
                    Please contact your system administrator to request permission.
                </p>
            </div>
            <ng-template pTemplate="footer">
                <button pButton label="Okay" (click)="service.close()"></button>
            </ng-template>
        </p-dialog>
    `,
    styles: `
        .permission-body {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 4px 0 8px;
        }
        .permission-icon {
            font-size: 1.5rem;
            color: var(--primary-color);
            margin-top: 2px;
        }
        p {
            margin: 0;
            font-size: 14px;
            line-height: 1.5;
        }
    `
})
export class PermissionRequestDialogComponent {
    readonly service = inject(PermissionRequestService);
}
